export const ADMIN = '/admin';
export const LOGIN = '/login';
export const TOS = '/tos';
export const PRIVACY = '/privacy';
export const TERMS_OF_CONDUCT = '/conduct';
